import { useDispatch } from "react-redux";
import {v4 as uuidv4} from "uuid";
import type ConstructionCalculationsNewPanelListItemProps from "./ConstructionCalculationsNewPanelListItemProps";
import useIssacToastHook from "../../../../hooks/useIssacToastHook";
import useCalculationNewHook from "../../../../hooks/useCalculationNewHook";
import { updateStatus, removeById } from "../../constructionCalculationsNewSlice";
import CalculationStatus from "../../../../types/CalculationStatus";
import IsaacToastWrapperType from "../../../../types/IsaacToastWrapperType";
import styles from "./constructionCalculationsNewPanelListItem.module.scss";
import IsaacCalculationBadges from "../../../../components/isaacCalculationBadges/IsaacCalculationBadges";
import ConstructionCalculationsNewPanelCalculationItem from "../sidePanelCalculationItem/ConstructionCalculationsNewPanelCalculationItem";

const ConstructionCalculationsNewPanelListItem: React.FunctionComponent<ConstructionCalculationsNewPanelListItemProps> = ({
    calculation,
    isAllowToTakeAction
}) => {
    const dispatch = useDispatch();

    const {withToast} = useIssacToastHook();
    const {stopCalculationById, deleteCalculationById} = useCalculationNewHook(); 

    const handleCalculationStop = (): void => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (async () => {
            await stopCalculationById(calculation.calculationId);
            dispatch(
                updateStatus({
                calculationId: calculation.calculationId,
                status: CalculationStatus.Interrupted,
                }),
            );
        })();
    };

    const handleCalculationDelete = (): void => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (async () => {
          dispatch(removeById(calculation.calculationId));
          await withToast(
            async () =>
              await deleteCalculationById(calculation.calculationId, uuidv4()),
            IsaacToastWrapperType.OnlyError,
          );
        })();
    };

    return (
        <div key={calculation.calculationId} className={`${styles.calculationBox}`}>
        <IsaacCalculationBadges
            isAllowToTakeAction={isAllowToTakeAction}
            isSelected={calculation.selected ?? false}
            status={CalculationStatus[calculation.status as CalculationStatus]}
            handleCalculationStop={handleCalculationStop}
            handleCalculationDelete={handleCalculationDelete}
        />

        <div className={`${styles.calculation} ${styles.calculationOpened}`}>
            <ConstructionCalculationsNewPanelCalculationItem calculation={calculation} />
        </div>
        </div>
  );
}

export default ConstructionCalculationsNewPanelListItem;